import {GetOrCreateManufacturer, useGetOrCreateManufacturerProps} from "../../project/DefaultManufacturer";
import {useContext, useState} from "react";
import {EditContext} from "../../../misc/scroller/EditProvider";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../api/API";
import {Button, DialogActions, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {useNavigate} from "react-router-dom";
import {Project, projectLabel} from "../../../api/Projects";
import {AutoComplete} from "../../project/shopdrawing/openings/AutoComplete";

export function CreatePurchaseOrder(props: {
    onDone(): void;
}) {

    const {getManufacturer, ...mfgProps} = useGetOrCreateManufacturerProps();
    const mfg2 = useGetOrCreateManufacturerProps();
    const getManufacturer2 = mfg2.getManufacturer;
    const ctx = useContext(EditContext);
    const nav = useNavigate();

    const createPo = useAsyncAction(async () => {
        const mfg = await getManufacturer();

        const value = await api.logistics.updatePurchaseOrder({
            status: "draft",
            supplier: mfg,
        } as any);

        await ctx.reload();

        ctx.onSelect.emit({
            id: value.id,
            index: 100,
            value: value,
            editing: false,
        })

        nav("/logistics/purchasing/" + value.id);

    }, [nav]);

    const createConfig = useAsyncAction(async (input: {
        project: number,
    }) => {
        const mfg = await getManufacturer2();

        const value = await api.configureSourcing.upsert({
            supplier: mfg,
            project: input.project,
        } as any)

        nav("/logistics/purchasing/configure-sourcing/" + value.id);
    }, [nav]);

    const [project, setProject] = useState<Project|null>(null);

    return (
        <Dialog2 open onClose={props.onDone}>
            <DialogTitle>
                Create Purchase Order
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} flexDirection="row">
                    <Grid item xs={6}>
                        <Typography variant="h6">
                            Door/Frame Sourcing
                        </Typography>
                        <Typography>
                            Split doors/frames into components for weld shop and suppliers.
                        </Typography>

                        <div style={{height: 8}}/>

                        <AutoComplete<Project>
                            label="Project"
                            fullWidth
                            search={async search => {
                                const rs = await api.projects.list({search: search, offset: 0, stage: "in-progress"});
                                return rs.data;
                            }}
                            value={project}
                            equals={(a, b) => a.id === b.id}
                            makeLabel={projectLabel}
                            onSelect={setProject}
                            size="small"
                        />

                        <div style={{height: 8}}/>

                        <GetOrCreateManufacturer {...mfg2} name="Supplier"/>

                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6">
                            Simple Order
                        </Typography>
                        <Typography>
                            Choose supplier and add products from to-source.
                        </Typography>

                        <div style={{height: 8}}/>

                        <GetOrCreateManufacturer {...mfgProps} name="Supplier"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button variant="contained" fullWidth onClick={() => {
                            createConfig.callback({
                                project: project?.id ?? 0,
                            });
                        }}>
                            Door/Frame Builder
                        </Button>
                        {createConfig.LoadingElement}
                    </Grid>
                    <Grid item xs={6}>
                        <Button variant="contained"  fullWidth onClick={() => {
                            createPo.callback({});
                        }}>
                            Simple Order
                        </Button>

                        {createPo.LoadingElement}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onDone}>Cancel</Button>
            </DialogActions>
        </Dialog2>
    )
}